import AppImpersonate from './AppImpersonate';

export default AppImpersonate;
